<div class="container-fluid enviam-dis-orders">
  <div class="row">
    <div class="col">
      <div class="header">
        <app-back-button [title]="'module.storungen.details.header' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
      </div>
      <h2 class="title">
        {{ 'module.storungen.details.title' | translate }}
      </h2>
      <p class="dis-order-details-content">
        {{ 'module.storungen.details.content1' | translate }}
      </p>
      <p class="dis-order-details-content">
        {{ 'module.storungen.details.content2' | translate }}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="embed-responsive embed-responsive-4by3 enviam-dis-orders-frame" *ngIf="!isIE11">
        <iframe title="storungen" class="embed-responsive-item" [src]="url"></iframe>
      </div>

      <img alt="warning-img" class="warning-message" src="./assets/images/ie11_storungen_message.png" *ngIf="isIE11" />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h2 class="title">
        {{ 'module.storungen.contact.title' | translate }}
      </h2>
      <p class="enviam-dis-orders-contact">
        {{ 'module.storungen.contact.content.contact1.title' | translate }}
        <span>
          {{ 'module.storungen.contact.content.contact1.number' | translate }}
        </span>
      </p>
      <p class="enviam-dis-orders-contact">
        {{ 'module.storungen.contact.content.contact2.title' | translate }}
        <span>
          {{ 'module.storungen.contact.content.contact2.number' | translate }}
        </span>
      </p>
      <p class="enviam-dis-orders-contact">
        {{ 'module.storungen.contact.content.description.title' | translate }}
        <span>
          {{ 'module.storungen.contact.content.description.text' | translate }}
        </span>
      </p>
    </div>
  </div>
</div>
